import React from 'react';
import { RadioGroup } from '@headlessui/react';
import tw, { TwStyle } from 'twin.macro';
import { labelDesign } from '@teetsh/app/src/components/Form/Label';

interface Option<T> {
  value: T;
  title: string;
}

type Size = 'sm' | 'xs';

interface Props<T> {
  options: Option<T>[];
  value?: T;
  onChange: (v: T) => void;
  label?: string;
  wrap?: boolean;
  isReadOnly?: boolean;
  size?: Size;
}

const textSize: { [K in Size]: TwStyle } = {
  sm: tw`text-sm`,
  xs: tw`text-xs`,
};

export default function SmallCards<T = string>(props: Props<T>) {
  const {
    options,
    value,
    onChange,
    label,
    isReadOnly,
    wrap,
    size = 'sm',
  } = props;
  return (
    <RadioGroup value={value} onChange={onChange} tw="mt-2">
      {label && (
        <RadioGroup.Label css={[labelDesign, tw`mb-2`]}>
          {label}
        </RadioGroup.Label>
      )}
      <div css={[wrap && tw`flex-wrap`]} tw="flex gap-3">
        {options.map(option => (
          <RadioGroup.Option
            disabled={isReadOnly}
            key={`${option.value}`}
            value={option.value}
            css={[
              tw`rounded-md py-3 px-3 flex items-center bg-white justify-center font-medium uppercase sm:flex-1 cursor-pointer focus:outline-none aria-disabled:cursor-default text-neutral-intense aria-disabled:bg-neutral-quiet`,
              tw`border border-neutral-quiet hover:border-brand-moderate aria-disabled:border-neutral-quiet`,
              textSize[size],
              value === option.value &&
                tw`bg-brand-moderate text-brand-intense ring-2 ring-brand-intense border-transparent!`,
            ]}
          >
            <RadioGroup.Label as="p">{option.title}</RadioGroup.Label>
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  );
}
